import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 固定資産増減合計表-集計単位-計上月度-マネージド条件 */
enum EntryDateSearchCondition {
  currentMonth = '101',
  currentQuarter = '102',
  currentHalf = '103',
  currentPeriod = '104',
  quarter1 = '105',
  quarter2 = '106',
  quarter3 = '107',
  quarter4 = '108',
}

const nameConfig = {
  currentMonth: new Map([
    [Locale.ja, '当月'],
    [Locale.en, 'Current Month'],
  ]),
  currentQuarter: new Map([
    [Locale.ja, '当四半期'],
    [Locale.en, 'Current Quarter'],
  ]),
  currentHalf: new Map([
    [Locale.ja, '当半期'],
    [Locale.en, 'Current Half'],
  ]),
  currentPeriod: new Map([
    [Locale.ja, '当期'],
    [Locale.en, 'Current Period'],
  ]),
  quarter1: new Map([
    [Locale.ja, '第1四半期'],
    [Locale.en, 'Quarter 1'],
  ]),
  quarter2: new Map([
    [Locale.ja, '第2四半期'],
    [Locale.en, 'Quarter 2'],
  ]),
  quarter3: new Map([
    [Locale.ja, '第3四半期'],
    [Locale.en, 'Quarter 3'],
  ]),
  quarter4: new Map([
    [Locale.ja, '第4四半期'],
    [Locale.en, 'Quarter 4'],
  ]),
};

const toEnum = rawValueToEnum(EntryDateSearchCondition, EntryDateSearchCondition.currentMonth);
const toDisplay = enumToName(EntryDateSearchCondition, nameConfig);
const toDisplayWithPrefix = enumToName(EntryDateSearchCondition, nameConfig, { prefix: true });

export const entryDateSearchCondition = {
  enum: EntryDateSearchCondition,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { EntryDateSearchCondition };
